import { useProjectCard } from 'root/src/client/web/list/listItemComponents/project/hooks/useProjectCard'
import { projectDeliveredKey, projectDeliveryPendingKey } from 'root/src/shared/constants/keys'
import ShareMenu from 'root/src/client/web/base/ShareMenu'
import clipHandler from 'root/src/client/logic/project/handlers/clipHandler'
import unescapeHtml from 'root/src/shared/util/unescapeHtml'
import format2Decimals from 'root/src/shared/util/format2Decimals'
import Pin from 'root/src/client/web/base/Pin'
import classNames from 'classnames'
import * as BlackCard from 'root/src/client/v2/common/components/BlackCard/BlackCard'
import { withProjectCardStyle } from 'root/src/client/web/list/listItemComponents/style'
import { useModal } from 'root/src/client/v2/common/contexts/modal.context'
import CancelIcon from '@material-ui/icons/Cancel'
import Tooltip from '@material-ui/core/Tooltip'
import { useDispatch } from 'react-redux'
import getPage from 'root/src/client/logic/list/thunks/getPage'
import { CREATOR_PROJECTS_LIST_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import RejectDareCardModal from 'root/src/client/web/list/listItemComponents/project/RejectDareCardModal'

const ProjectPin = () => {
	const {
		project: { isPinnedDare },
		actions: { onPinProject },
		extraData: { displayPin },
	} = useProjectCard()

	if (!displayPin) {
		return null
	}

	const pinLabel = isPinnedDare ? 'Unpin Dare' : 'Pin Dare'
	return (
		<Tooltip title={pinLabel} arrow>
			<div
				role="button"
				tabIndex={0}
				aria-label={pinLabel}
				onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onPinProject(e) }}
				className="opacity-60 hover:opacity-100 transition-opacity"
				style={{ padding: 8 }}
			>
				<Pin active={isPinnedDare} onClick={onPinProject} hideTooltip size={18} noBrightness />
			</div>
		</Tooltip>
	)
}

const ProjectReject = () => {
	const {
		project: { projectUrl },
		extraData: { displayReject },
	} = useProjectCard()
	const modal = useModal()
	const dispatch = useDispatch()

	if (!displayReject) {
		return null
	}

	const onSuccess = () => {
		dispatch(getPage(1, CREATOR_PROJECTS_LIST_MODULE_ID))
	}

	return (
		<Tooltip title="Reject Dare" arrow>
			<button
				type="button"
				aria-label="Reject Dare"
				onClick={(e) => {
					e.preventDefault()
					e.stopPropagation()
					modal.show(
						<RejectDareCardModal
							projectUrl={projectUrl}
							onSuccess={onSuccess}
						/>,
					)
				}}
				className="opacity-60 hover:opacity-100 transition-opacity"
				style={{
					cursor: 'pointer',
					padding: 8,
					background: 'none',
					border: 'none',
					color: 'inherit',
				}}
			>
				<CancelIcon className="*:fill-pink" style={{ width: 22, height: 22 }} />
			</button>
		</Tooltip>
	)
}

const ProjectCardTitle = withProjectCardStyle(({
	classes, title,
}) => <p className={classNames(classes.projectTitle, classes.textTruncate)}>{title}</p>)

const ProjectCardDescription = withProjectCardStyle(({ classes, description }) => (
	<div className={classNames(
		classes.descriptionContainer,
		classes.descriptionContainerClamp2,
	)}
	>
		<p className={classes.descriptionText}>
			{clipHandler(unescapeHtml(description), 80)}
		</p>
	</div>
))

export const ProjectCardDetails = withProjectCardStyle(({ classes }) => {
	const {
		project: {
			brandProduct,
			title,
			description,
			games, creatorData,
			status,
			pledgeAmount,
			shareUrl,
			capacity,
			rewardFor,
		},
		extraData: { goalAmount },
	} = useProjectCard()

	const completed = status === projectDeliveredKey

	return (
		<div className={classes.footerBody}>
			<div>
				<div className={classes.footerHeaderContainer}>
					<BlackCard.Caption
						title={games.map(game => game.name).join(', ')}
						className={classes.gameTitle}
					/>
					<div style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
					>
						<ProjectPin />
						<Tooltip title="Share" arrow>
							<div>
								<ShareMenu url={shareUrl} className="opacity-60 hover:opacity-100 transition-opacity" />
							</div>
						</Tooltip>
						<ProjectReject />
					</div>
				</div>
				<div style={{ margin: '0px 0px' }}>
					<ProjectCardTitle title={clipHandler(unescapeHtml(title))} />
					<ProjectCardDescription classes={classes} description={description} />
				</div>
			</div>
			{!completed && (
				<div style={{
					display: 'flex',
					justifyContent: 'space-between',
					margin: '5px 0px',
				}}
				>
					<ProjectCardReward
						status={status}
						displayName={creatorData?.displayName}
						capacity={capacity}
						rewardFor={rewardFor}
						brandProduct={brandProduct}
					/>
					{(!brandProduct && !brandProduct?.amount) && (
						<BlackCard.HighlightedSection
							title="TOTAL PLEDGED"
							text={`$${format2Decimals(pledgeAmount)}${goalAmount ? ` of $${format2Decimals(goalAmount)}` : ''}`}
						/>
					)}
				</div>
			)}
		</div>
	)
})

function ProjectCardReward({ status, displayName, capacity, brandProduct }) {
	if ((displayName && status === projectDeliveryPendingKey)
		|| !capacity
		|| !brandProduct?.amount
	) {
		if (displayName) {
			return (
				<BlackCard.HighlightedSection
					title="CREATED BY"
					text={displayName}
				/>
			)
		}
	}
	return null
}
